export const CUBA_APP_URL = process.env.REACT_APP_CUBA_URL || "/app/rest/";
export const CUBA_APP_NOTIFICATION_WS_URL =
  process.env.REACT_APP_CUBA_NOTIFICATION_WS_URL || "/kms-core/ws/handler";

export const DEFAULT_COUNT = 10; // Typical amount of entities to be loaded on browse screens
